import { useState } from 'react';
import styles from './PasswordInput.module.css';

// Campo de contraseña con botón "ojito" para mostrar/ocultar lo escrito.
// Reenvía el resto de props al <input> (name, value, onChange, placeholder,
// required, autoComplete, disabled, maxLength…).
export default function PasswordInput({ className = 'form-control', style, ...rest }) {
  const [show, setShow] = useState(false);

  return (
    <div className={styles.contenedor}>
      <input
        {...rest}
        type={show ? 'text' : 'password'}
        className={`${className} ${styles.campo}`}
        style={style}
      />
      <button
        type="button"
        onClick={() => setShow(s => !s)}
        aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        aria-pressed={show}
        tabIndex={-1}
        title={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        className={styles.ojo}
      >
        <i className={`fas ${show ? 'fa-eye-slash' : 'fa-eye'}`} />
      </button>
    </div>
  );
}
